import VideoBlock, { VideoBlockProps } from '../../../videoBlock/VideoBlock';

export type MarkdownVideoProps = VideoBlockProps;

export const MarkdownVideo = ({
	className,
	controls = true,
	playsinline = true,
	...props
}: MarkdownVideoProps) => {
	return (
		<div className={className} data-cmp="Video">
			<VideoBlock {...props} controls={controls} playsinline={playsinline} />
		</div>
	);
};
